import React from "react";
import { pure } from "recompose";
import { sumBy } from "lodash";

import OnePanel from "./OnePanel";
import Text from "./Text";

const UnitCosts2 = pure(({ manufactureCosts, teamId, round, rounds }) => {
  const roundId = rounds.find(i => i.number === round).id;
  const data = manufactureCosts.filter(
    i => i.team === teamId && i.round === roundId
  );
  const unitsProduced = sumBy(data, "units_produced");
  const avgMaterialCostsPerUnit = (
    unitsProduced !== 0 ? sumBy(data, "material_costs") / unitsProduced : 0
  ).toFixed(2);
  const avgLaborCostsPerUnit = (
    unitsProduced !== 0 ? sumBy(data, "labor_costs") / unitsProduced : 0
  ).toFixed(2);
  const avgOverheadCostsPerUnit = (
    unitsProduced !== 0 ? sumBy(data, "overhead_costs") / unitsProduced : 0
  ).toFixed(2);
  const avgProductsUnitCosts = (
    parseFloat(avgMaterialCostsPerUnit) +
    parseFloat(avgLaborCostsPerUnit) +
    parseFloat(avgOverheadCostsPerUnit)
  ).toFixed(2);

  return (
    <OnePanel title="Unit Costs Breakdown">
      <div
        style={{
          marginTop: "-20px"
        }}
      >
        <Text>
          <span
            style={{
              fontSize: "16px",
              color: "#999"
            }}
          >
            Direct Materials, Labor, and Overhead drives your product costs. The
            costs below is a breakdown of the average unit costs of all your
            products.
          </span>
        </Text>
      </div>
      <div className="team-reports-operational-analysis">
        <table>
          <tbody>
            <tr>
              <td className="price">${avgMaterialCostsPerUnit}</td>
              <td>+</td>
              <td className="price">${avgLaborCostsPerUnit}</td>
              <td>+</td>
              <td className="price">${avgOverheadCostsPerUnit}</td>
              <td>=</td>
              <td className="price">${avgProductsUnitCosts}</td>
            </tr>
            <tr>
              <td className="price-description">
                Material
                <br />
                Costs Per Unit
              </td>
              <td />
              <td className="price-description">
                Labor
                <br />
                Costs Per Unit
              </td>
              <td />
              <td className="price-description">
                Overhead
                <br />
                Costs Per Unit
              </td>
              <td />
              <td className="price-description">
                Product's
                <br />
                Unit Costs
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </OnePanel>
  );
});

export default UnitCosts2;



// WEBPACK FOOTER //
// ./src/components/analysis/UnitCosts2.js